import type {IContact} from '../interfaces/IContact';
import '../css/courselist.scss';
import { Box } from '@mui/material';


interface ICourse {
    shortName: string;
    name: string;
    day: IDay;
    isVisible: boolean;
    nbMaxRegistrations: number;
    startTime: string;
    endTime: string;
  }

  interface IStage {
    shortName: string;
    name: string;
    description: string;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
  }
  
  interface IDay {
    name: string;
  }

  interface ICourseObj {
    course: ICourse;
    subscribes: IContact[];
  }

interface IProps {
    courses: undefined | ICourseObj[];
    stages: undefined | IStage[];
    title: string;
}

const niceTime = (time: string) => {
    if (time === null)
        return '';
    const tokens = time.split(':');
    return `${tokens[0]}h${tokens[1]}`;
  };

const CourseList = ({ courses, title}:IProps) => {

    return (
        <Box id="course-list"
        sx={(theme) => ({
          backgroundColor: theme.palette.mode === "dark"
            ? 'rgba(226, 255, 152, 0.8)' : 'rgba(220,220,150, .7)',
          color:  theme.palette.mode === "dark"
           ? 'rgb(100,50,155)'
           : 'rgb(100,50,155)',
        })} 
            >
            <h2>{title}</h2>
            {courses !== undefined ?
                            courses.filter((li) => li.course.isVisible).map((li) =>{
                                const schedule = li.course.day?.name !== '' ? ` (${li.course.day?.name} de ${niceTime(li.course.startTime)} à ${niceTime(li.course.endTime)})`  : '';
                                return (
                                    <p key={li.course.shortName} className="course">{li.course.name}{schedule}</p>
                                );
                            })
                    : <div/>
                    }

        </Box>
    )
}

export default CourseList;
